import { width } from "@mui/system";
import React, { useEffect, useState, useRef, useContext } from "react";
import Button from "react-bootstrap/Button";
import "react-toastify/dist/ReactToastify.css";
import styles from "./FilterName.module.scss";
import { IndexContext } from "../layout/Layout";

function FilterName({
  filter,
  filterType,
  setPercentage,
  setFilter1Name,
  setFilter2Name,
  setSelectedInternalFilters,
}) {
  //-------------------------------------------IndexContext
  const IndexProvider = useContext(IndexContext);
  let PIS = IndexProvider.indexStyle;

  //-------------------------------------------IndexContext

  const selectComparisonBtn = (obj, type) => {
    let newArr = [
      {
        columnId: obj.columnId,
        filterValue: obj.value,
        queryId: obj.queryId,
      },
    ];

    obj.columnId && obj.value && setSelectedInternalFilters(newArr);
    if (type === "normal") {
      setFilter1Name((prevData) => ({
        ...prevData,
        active: true,
      }));
      setFilter2Name((prevData) => ({
        ...prevData,
        active: false,
      }));
    } else {
      setFilter1Name((prevData) => ({
        ...prevData,
        active: false,
      }));
      setFilter2Name((prevData) => ({
        ...prevData,
        active: true,
      }));
    }
  };

  return (
    <span
      className={`${styles.comparisonName}  ${
        filter && filter.active && styles.active
      }`}
      onClick={() => {
        setPercentage && setPercentage(true);
        selectComparisonBtn(filter && filter, filterType);
      }}
    >
      {filter && filter.value}
    </span>
  );
}

export default FilterName;
